/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-08-13
 */

import taskApi from "./taskApi";

// Auth
export { requestLoginOtp, verifyLoginOtp } from "./authApi";
export type {
  RequestOtpInput,
  VerifyOtpInput,
  VerifyOtpApiResponse,
} from "../features/auth/model/types";

// Projects
export {
  getProjects,
  updateProject,
  getProjectFormDependencies,
} from "./projectRepository";
export {
  getProjectExportApi,
  fetchProjectTypesApi,
  fetchTaskCategoriesApi,
} from "./projectApi";
export type {
  ProjectListQuery,
  ProjectListResult,
  ProjectRecord,
  UpdateProjectInput,
  ProjectExportApiResponse,
  ProjectFormDependencies,
  ProjectFormDependenciesInput,
  FetchProjectTypesInput,
  FetchTaskCategoriesInput,
  OptionsApiResponse,
  ProjectOption,
} from "../features/projects/model/types";

// Dashboard
export { getDashboardProjectAnalytics } from "./dashboardRepository";
export type {
  DashboardProjectAnalyticsQuery,
  DashboardProjectAnalyticsResult,
  DashboardProjectAnalyticsRecord,
} from "../features/dashboard/model/types";

// Tasks
export {
  getAuthTokenFromLocalStorage,
  logoutCurrentSession,
  headers,
  createRoute,
  fetchConfigOptions,
  downloadFileFromUrl,
  handleAxiosError,
} from "./taskApi";

export { taskApi };
export default taskApi;
